const getDescription = apiDescription =>
  apiDescription ? { description: apiDescription } : null;

export default getDescription;
